function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Date.prototype.toString.call(Reflect.construct(Date, [], function () {})); return true; } catch (e) { return false; } }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';
import { classNamesFor } from '../utils/classNames';
import Button from '../Button';
import Icon from '../Icon';
import Media from '../Media';
var paymentMethodIdsToImageName = {
  AMEX: 'american-express',
  BOKU: 'boku',
  DISCOVER: 'discover',
  MC: 'mastercard',
  PAYPAL: 'paypal',
  PAYPALDI: 'paypal',
  VISA: 'visa'
};

var getHeadline = function getHeadline(_ref) {
  var useWallet = _ref.useWallet,
      hasEnoughFunds = _ref.hasEnoughFunds,
      walletBalance = _ref.walletBalance,
      totalCartPrice = _ref.totalCartPrice,
      paymentInstrument = _ref.paymentInstrument;
  if (useWallet) return hasEnoughFunds ? totalCartPrice : walletBalance;
  if (paymentInstrument) return paymentInstrument;
  return 'Add New Payment Method';
}; // eslint-disable-next-line


var getImage = function getImage(_ref2) {
  var useWallet = _ref2.useWallet,
      paymentInstrument = _ref2.paymentInstrument,
      paymentMethodId = _ref2.paymentMethodId;
  if (useWallet) return /*#__PURE__*/React.createElement(Icon, {
    type: "ps-store"
  });

  if (paymentInstrument) {
    return /*#__PURE__*/React.createElement(Media, {
      aspectRatio: "8:5",
      type: "image",
      width: 56,
      src: "payment-vendor/".concat(paymentMethodIdsToImageName[paymentMethodId], ".png"),
      alt: paymentMethodId,
      useStatic: true
    });
  }

  return /*#__PURE__*/React.createElement(Icon, {
    type: "ps-store"
  });
};
/**
 * :construction: Currently under construction :construction_worker:
 *
 * # TODO:
 * - [ ] Should this component be dumber?
 * - [ ] Wire in formating of strings
 *
 * The PaymentSelector component provides an affordance for a user to view currently
 * selected payment methods and the ability to signal that they would like to change / update
 * a payment method
 *
 * - [Metropolis Style Guide - Payment Selector](https://confluence.sie.sony.com/display/PPRC1/Payment+Selector)
 *
 * ## Related Components
 * - [Metropolis Style Guide - Game Version Select](https://confluence.sie.sony.com/display/PPRC1/Game+Version+Select)
 *
 * ## Usage
 *
 * ```jsx
 * <PaymentSelector ctaType="primary" variant="outline" />
 * ```
 *
 * ## Props
 */


var PaymentSelector = /*#__PURE__*/function (_PureComponent) {
  _inherits(PaymentSelector, _PureComponent);

  var _super = _createSuper(PaymentSelector);

  function PaymentSelector() {
    _classCallCheck(this, PaymentSelector);

    return _super.apply(this, arguments);
  }

  _createClass(PaymentSelector, [{
    key: "render",
    value: function render() {
      var _this$props = this.props,
          id = _this$props.id,
          ariaLabel = _this$props.ariaLabel,
          qa = _this$props.qa,
          className = _this$props.className,
          paymentMethodId = _this$props.paymentMethodId,
          paymentInstrument = _this$props.paymentInstrument,
          walletBalance = _this$props.walletBalance,
          totalCartPrice = _this$props.totalCartPrice,
          useWallet = _this$props.useWallet,
          onAddPaymentMethod = _this$props.onAddPaymentMethod,
          onChangePaymentMethod = _this$props.onChangePaymentMethod,
          isDefault = _this$props.isDefault;
      var hasEnoughFunds = parseFloat(walletBalance, 10) >= parseFloat(totalCartPrice, 10);
      var hasPaymentInstrument = !useWallet && paymentInstrument;
      var hasPaymentSource = useWallet || hasPaymentInstrument;

      var _PaymentSelector$getC = PaymentSelector.getClassName({
        className: className,
        hasEnoughFunds: hasEnoughFunds
      }),
          root = _PaymentSelector$getC.root,
          contentContainer = _PaymentSelector$getC.contentContainer,
          info = _PaymentSelector$getC.info,
          headlineClass = _PaymentSelector$getC.headline,
          subHeadline = _PaymentSelector$getC.subHeadline;

      var headline = getHeadline({
        useWallet: useWallet,
        hasEnoughFunds: hasEnoughFunds,
        walletBalance: walletBalance,
        totalCartPrice: totalCartPrice,
        paymentInstrument: paymentInstrument
      });
      var image = getImage({
        useWallet: useWallet,
        paymentInstrument: paymentInstrument,
        paymentMethodId: paymentMethodId
      });
      return /*#__PURE__*/React.createElement(Button, {
        id: id,
        qa: qa,
        arialLabel: ariaLabel,
        className: root,
        variant: "content",
        onClick: hasPaymentSource ? onChangePaymentMethod : onAddPaymentMethod
      }, /*#__PURE__*/React.createElement("div", {
        className: contentContainer
      }, image, /*#__PURE__*/React.createElement("div", {
        className: info
      }, /*#__PURE__*/React.createElement("h1", {
        className: headlineClass
      }, headline), hasPaymentInstrument && isDefault && /*#__PURE__*/React.createElement("p", {
        className: subHeadline
      }, "Default Card"), useWallet && /*#__PURE__*/React.createElement("p", {
        className: subHeadline
      }, "From PS Wallet"))), /*#__PURE__*/React.createElement(Icon, {
        type: hasPaymentSource ? 'chevron-right' : 'plus'
      }));
    }
  }]);

  return PaymentSelector;
}(PureComponent);

var cx = classNamesFor(PaymentSelector);
/**
 * Gets the classNames attached to the style hooks for this component.
 * @returns {string} the aliased classNames for PaymentSelector
 */

PaymentSelector.getClassName = function (_ref3) {
  var className = _ref3.className,
      hasEnoughFunds = _ref3.hasEnoughFunds;
  return {
    root: cx('psw-payment-selector', 'psw-l-line-repel', 'psw-p-m', 'psw-round-m', {
      'psw-has-icon': !hasEnoughFunds
    }, className),
    contentContainer: cx('psw-l-line-left', 'psw-l-space-x-xs'),
    info: cx('psw-payment-selector-info', 'psw-fill-x', 'psw-l-line-enable-truncation'),
    headline: cx('psw-h5', 'psw-truncate-text-1'),
    subHeadline: cx('psw-body-3')
  };
};
/**
 * Defines aliases for classNames used by this component
 */


PaymentSelector.useClassNames = function (classNames) {
  PaymentSelector.classNames = classNames;
};

PaymentSelector.defaultProps = {
  qa: '',
  id: '',
  ariaLabel: '',
  className: '',
  paymentMethodId: '',
  paymentInstrument: '',
  totalCartPrice: '',
  walletBalance: '',
  useWallet: false,
  isDefault: false,
  onAddPaymentMethod: function onAddPaymentMethod() {},
  onChangePaymentMethod: function onChangePaymentMethod() {}
};
PaymentSelector.propTypes = {
  /**
   * QA selector attribute used to target important elements for test validation
   */
  qa: PropTypes.string,

  /**
   * The unique identifier for the button element
   */
  id: PropTypes.string,

  /**
   * Aria label for button. Be aware that screen reader will always use this value if provided
   */
  ariaLabel: PropTypes.string,

  /**
   * Allows adding a custom class or series of classes on the component
   * useful for setting margin or padding
   */
  className: PropTypes.string,
  paymentMethodId: PropTypes.string,
  paymentInstrument: PropTypes.string,
  isDefault: PropTypes.bool,
  totalCartPrice: PropTypes.string,
  walletBalance: PropTypes.string,
  useWallet: PropTypes.bool,

  /**
   * event callback to be called when a user clicks to add a payment method
   */
  onAddPaymentMethod: PropTypes.func,

  /**
   * event callback to be called when a user clicks to update their selected payment method
   */
  onChangePaymentMethod: PropTypes.func
  /**
   * children to be rendered within the
   */
  // children: PropTypes.node,

};
export default PaymentSelector;